{
    "Trades-Quick-Search-Fields": [
        {
            "label": "Event Type", "columnname": "EventType", "placeholder": "Event Type",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OMS Order ID", "columnname": "OMSOrderID", "placeholder": "OMS Order ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Trade ID", "columnname": "TradeID", "placeholder": "Trade ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Execution Venue", "columnname": "ExecutionVenue", "placeholder": "Execution Venue",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "OMSSystem", "columnname": "OMSSystem", "placeholder": "OMSSystem",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "Trades-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "EventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Date Time",
            "db_columnname": "TradeDateTime",
            "datatype": "DateTime",
            "mappingkey": "tradeDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "System Date Time",
            "db_columnname": "SystemDateTime",
            "datatype": "DateTime",
            "mappingkey": "systemDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderDateTime",
            "db_columnname": "orderDateTime",
            "datatype": "String",
            "mappingkey": "orderDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade ID",
            "db_columnname": "TradeID",
            "datatype": "String",
            "mappingkey": "tradeID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OMS Order ID",
            "db_columnname": "OMSOrderID",
            "datatype": "String",
            "mappingkey": "oMSOrderId",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order ID",
            "db_columnname": "OrderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Act Ref Num",
            "db_columnname": "ActRefNum",
            "datatype": "String",
            "mappingkey": "actRefNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "BuySellCode",
            "datatype": "String",
            "mappingkey": "buySellCode",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trd Qty",
            "db_columnname": "Quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Leaves Qty",
            "db_columnname": "LeavesQty",
            "datatype": "float",
            "mappingkey": "leavesQty",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trd Price",
            "db_columnname": "Price",
            "datatype": "Float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Capacity",
            "db_columnname": "Capacity",
            "datatype": "String",
            "mappingkey": "capacity",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Execution Venue",
            "db_columnname": "ExecutionVenue",
            "datatype": "String",
            "mappingkey": "executionVenue",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Contra Broker MPID",
            "db_columnname": "ContraBrokerMPID",
            "datatype": "String",
            "mappingkey": "contraBrokerMPID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Branch Seq Num",
            "db_columnname": "BranchSeqNum",
            "datatype": "String",
            "mappingkey": "branchSeqNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cross Trade RefNum",
            "db_columnname": "CrossTradeRefNum",
            "datatype": "String",
            "mappingkey": "crossTradeRefNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Report",
            "db_columnname": "tradeReport",
            "datatype": "String",
            "mappingkey": "tradeReport",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ReportingExcpCode",
            "db_columnname": "reportingExcpCode",
            "datatype": "String",
            "mappingkey": "reportingExcpCode",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Modifier",
            "db_columnname": "TradeModifier",
            "datatype": "String",
            "mappingkey": "tradeModifier",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Bid Price",
            "db_columnname": "BidPrice",
            "datatype": "Float",
            "mappingkey": "bidPrice",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ask Price",
            "db_columnname": "AskPrice",
            "datatype": "Float",
            "mappingkey": "askPrice",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Tick Test",
            "db_columnname": "TickTest",
            "datatype": "String",
            "mappingkey": "tickTest",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Tick Direction",
            "db_columnname": "TickDirection",
            "datatype": "String",
            "mappingkey": "tickDirection",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "As Of",
            "db_columnname": "AsOf",
            "datatype": "DateTime",
            "mappingkey": "asOf",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "As Of Date Time",
            "db_columnname": "AsOfDateTime",
            "datatype": "DateTime",
            "mappingkey": "asOfDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Late Trade",
            "db_columnname": "LateTrade",
            "datatype": "String",
            "mappingkey": "lateTrade",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "PRP Date Time",
            "db_columnname": "PRPDateTime",
            "datatype": "DateTime",
            "mappingkey": "pRPDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Thru",
            "db_columnname": "TradeThru",
            "datatype": "String",
            "mappingkey": "tradeThru",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Position",
            "db_columnname": "Position",
            "datatype": "Int",
            "mappingkey": "position",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Liquidity Flag",
            "db_columnname": "LiquidityFlag",
            "datatype": "String",
            "mappingkey": "liquidityFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Negotiated Trade",
            "db_columnname": "NegotiatedTrade",
            "datatype": "String",
            "mappingkey": "negotiatedTrade",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Locate Info",
            "db_columnname": "LocateInfo",
            "datatype": "String",
            "mappingkey": "locateInfo",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Acct type",
            "db_columnname": "AcctType",
            "datatype": "String",
            "mappingkey": "acctType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trader Account",
            "db_columnname": "TraderAccount",
            "datatype": "String",
            "mappingkey": "traderAccount",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cst Branch",
            "db_columnname": "CustBranch",
            "datatype": "String",
            "mappingkey": "custBranch",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Cust Rep",
            "db_columnname": "CustRep",
            "datatype": "String",
            "mappingkey": "custRep",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ISO Num",
            "db_columnname": "ISONum",
            "datatype": "String",
            "mappingkey": "iSONum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Barrier ID",
            "db_columnname": "BarrierID",
            "datatype": "String",
            "mappingkey": "barrierID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Contra Acct",
            "db_columnname": "ContraAcct",
            "datatype": "String",
            "mappingkey": "contraAcct",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Settle Date",
            "db_columnname": "SettleDate",
            "datatype": "DateTime",
            "mappingkey": "settleDate",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Execution type",
            "db_columnname": "ExecutionType",
            "datatype": "String",
            "mappingkey": "executionType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Delivery Instructions",
            "db_columnname": "DeliveryInstructions",
            "datatype": "String",
            "mappingkey": "deliveryInstructions",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Exchange Trade Ref Num",
            "db_columnname": "ExchangeTradeRefNum",
            "datatype": "String",
            "mappingkey": "exchangeTradeRefNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ext Branch Seq Num",
            "db_columnname": "extBranchSeqNum",
            "datatype": "String",
            "mappingkey": "ExtBranchSeqNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ext Order Ref Num",
            "db_columnname": "extOrderRefNum",
            "datatype": "String",
            "mappingkey": "ExtOrderRefNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Clearing Broker MPID",
            "db_columnname": "ClearingBrokerMPID",
            "datatype": "String",
            "mappingkey": "clearingBrokerMPID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Give Up Broker MPID",
            "db_columnname": "GiveUpBrokerMPID",
            "datatype": "String",
            "mappingkey": "giveUpBrokerMPID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order Desk",
            "db_columnname": "OrderDesk",
            "datatype": "String",
            "mappingkey": "orderDesk",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OE Type",
            "db_columnname": "OEType",
            "datatype": "String",
            "mappingkey": "oEType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Terminal User",
            "db_columnname": "TerminalUser",
            "datatype": "String",
            "mappingkey": "terminalUser",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Bid Size",
            "db_columnname": "BidSize",
            "datatype": "Int",
            "mappingkey": "bidSize",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Ask Size",
            "db_columnname": "AskSize",
            "datatype": "Int",
            "mappingkey": "askSize",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Market Seq Num",
            "db_columnname": "MarketSeqNum",
            "datatype": "String",
            "mappingkey": "marketSeqNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Info1",
            "db_columnname": "info1",
            "datatype": "String",
            "mappingkey": "info1",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Info2",
            "db_columnname": "info2",
            "datatype": "String",
            "mappingkey": "info2",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ReceiveMethod",
            "db_columnname": "receiveMethod",
            "datatype": "String",
            "mappingkey": "receiveMethod",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustomerType",
            "db_columnname": "customerType",
            "datatype": "String",
            "mappingkey": "customerType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RootOrderID",
            "db_columnname": "rootOrderID",
            "datatype": "String",
            "mappingkey": "rootOrderID",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Order Version Num",
            "db_columnname": "orderVersionNum",
            "datatype": "String",
            "mappingkey": "orderVersionNum",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Strategy",
            "db_columnname": "strategy",
            "datatype": "String",
            "mappingkey": "strategy",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Strategy Detail",
            "db_columnname": "strategyDetail",
            "datatype": "String",
            "mappingkey": "strategyDetail",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Instrument Type",
            "db_columnname": "InstrumentType",
            "datatype": "String",
            "mappingkey": "instrumentType",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "QuotingMPID",
            "db_columnname": "quotingMPID",
            "datatype": "String",
            "mappingkey": "quotingMPID",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "EnteredBy",
            "db_columnname": "enteredBy",
            "datatype": "String",
            "mappingkey": "enteredBy",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "EnteredDateTime",
            "db_columnname": "enteredDateTime",
            "datatype": "String",
            "mappingkey": "enteredDateTime",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradeFlags",
            "db_columnname": "tradeFlags",
            "datatype": "String",
            "mappingkey": "tradeFlags",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradeState",
            "db_columnname": "tradeState",
            "datatype": "String",
            "mappingkey": "tradeState",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ISIN",
            "db_columnname": "iSIN",
            "datatype": "String",
            "mappingkey": "iSIN",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "LastMarket",
            "db_columnname": "lastMarket",
            "datatype": "String",
            "mappingkey": "lastMarket",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "bFMMFlag",
            "datatype": "char",
            "mappingkey": "bFMMFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SeqNum",
            "db_columnname": "UserDefined1",
            "datatype": "String",
            "mappingkey": "userDefined1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboSource",
            "db_columnname": "UserDefined2",
            "datatype": "String",
            "mappingkey": "userDefined2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboTimestamp",
            "db_columnname": "PRPDateTime",
            "datatype": "String",
            "mappingkey": "pRPDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OMSSystem",
            "db_columnname": "OMSSystem",
            "datatype": "String",
            "mappingkey": "oMSSystem",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File ID",
            "db_columnname": "ClientDataHeaderID",
            "datatype": "int",
            "mappingkey": "clientDataHeaderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "user",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "FirmMPID",
            "datatype": "String",
            "mappingkey": "firmMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "TradeKeyDate",
            "db_columnname": "TradeDate",
            "datatype": "DateTime",
            "mappingkey": "tradeDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "MultiLegInd",
            "db_columnname": "MultiLegInd",
            "datatype": "String",
            "mappingkey": "multiLegInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "InfoBarrierID",
            "db_columnname": "infoBarrierID",
            "datatype": "String",
            "mappingkey": "infoBarrierID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "Trades-Opted-Export-CSV-Grid-Columns": [
        {
            "columnName": "CATReporterIMID",
            "dbFieldValue": "FirmMPID"
        },
        {
            "columnName": "Type",
            "dbFieldValue": "EventType"
        },
        {
            "columnName": "Trade ID",
            "dbFieldValue": "TradeID"
        },
        {
            "columnName": "Order ID",
            "dbFieldValue": "OrderID"
        },
        {
            "columnName": "ElectronicTimestamp",
            "dbFieldValue": "SystemDateTime"
        },
        {
            "columnName": "EventTimestamp",
            "dbFieldValue": "TradeDateTime"
        },
        {
            "columnName": "Symbol",
            "dbFieldValue": "Symbol"
        },
        {
            "columnName": "Side",
            "dbFieldValue": "BuySellCode"
        },
        {
            "columnName": "Quantity",
            "dbFieldValue": "Quantity"
        },
        {
            "columnName": "Price",
            "dbFieldValue": "Price"
        },
        {
            "columnName": "MarketCenterID",
            "dbFieldValue": "ExecutionVenue"
        },
        {
            "columnName": "Capacity",
            "dbFieldValue": "Capacity"
        },
        {
            "columnName": "ActRefNum",
            "dbFieldValue": "ActRefNum"
        },
        {
            "columnName": "TapeTradeID",
            "dbFieldValue": "BranchSeqNum"
        },
        {
            "columnName": "clearingFirm",
            "dbFieldValue": "ClearingBrokerMPID"
        },
        {
            "columnName": "Counterparty",
            "dbFieldValue": "ContraBrokerMPID"
        },
        {
            "columnName": "SystemGroup",
            "dbFieldValue": "OMSSystem"
        },
        {
            "columnName": "TradeKeyDate",
            "dbFieldValue": "TradeDate"
        },
        {
            "columnName": "ManualFlag",
            "dbFieldValue": "receiveMethod"
        },
        {
            "columnName": "orderKeyDate",
            "dbFieldValue": "orderDateTime"
        },
        {
            "columnName": "ReportingExceptionCode",
            "dbFieldValue": "ReportingExcpCode"
        },
        {
            "columnName": "AccountHolderType",
            "dbFieldValue": "CustomerType"
        },
        {
            "columnName": "InstrumentType",
            "dbFieldValue": "InstrumentType"
        },
        {
            "columnName": "multiLegInd",
            "dbFieldValue": "MultiLegInd"
        },
        {
            "columnName": "InfoBarrierID",
            "dbFieldValue": "infoBarrierID"
        },
        {
            "columnName": "BFMMFlag",
            "dbFieldValue": "BFMMFlag"
        },
        {
            "columnName": "SeqNum",
            "dbFieldValue": "userDefined1"
        },
        {
            "columnName": "NbboSource",
            "dbFieldValue": "userDefined2"
        },
        {
            "columnName": "NbboTimestamp",
            "dbFieldValue": "pRPDateTime"
        }
    ]
}